import { toLower } from 'lodash'
import { extractOnlyNumbers, normalizeText } from '@/core/utils/formatter'

export const compareTextLettersOnly = (value, queryText) =>
  toLower(normalizeText(value)).includes(toLower(normalizeText(queryText)))
export const equalsTextLettersOnly = (value, queryText) =>
  toLower(normalizeText(value)) === toLower(normalizeText(queryText))
export const compareRaizCnpj = (empresa1, empresa2) => {
  const raizCnpjEmpresa1 = empresa1 ? empresa1.slice(0, 8) : ''
  const raizCnpjEmpresa2 = empresa2 ? empresa2.slice(0, 8) : ''

  return raizCnpjEmpresa1 === raizCnpjEmpresa2
}
export const filtroEmpresaCnpjRazaoSocial = ({ razao_social, cnpj, cpf }, queryText) => {
  if (compareTextLettersOnly(razao_social, queryText)) return true
  if (/[a-zA-ZÀ-ÿ]/.test(queryText)) return false

  const numeros = extractOnlyNumbers(queryText)
  if (!numeros) return false

  return [cnpj, cpf].some(documento => extractOnlyNumbers(documento).includes(numeros))
}

export default compareTextLettersOnly
